<template>
  <v-card-title class="shop-header d-flex align-center flex-wrap ga-2">
    <v-chip
      v-if="order"
      :href="orderLink ? `/orders/${order.assignId}` : undefined"
      :target="orderLink ? '_blank' : undefined"
      :rel="orderLink ? 'noopener' : undefined"
      >Order #{{ order.assignId }} / {{ order.orderStatus }}</v-chip
    >
    <span v-else>Opening order</span>
    <v-chip
      v-if="order && editableBuyer"
      :disabled="busy"
      @click="$emit('edit-buyer')"
    >
      Buyer: {{ order.personId?.name ?? "Anonymous buyer"
      }}<template v-if="order.personId">
        / {{ order.personId.personId }}</template
      >
    </v-chip>
    <v-chip
      v-else-if="order"
      :to="
        buyerLink && order.personId
          ? `/person/${order.personId.personId}`
          : undefined
      "
    >
      Buyer: {{ order.personId?.name ?? "Anonymous buyer"
      }}<template v-if="order.personId">
        / {{ order.personId.personId }}</template
      >
    </v-chip>
    <slot name="details" />
    <v-spacer />
    <v-btn
      :disabled="busy || !order || receiptDisabled"
      :aria-pressed="receiptToggleMode ? printSelected : undefined"
      :color="receiptToggleMode && printSelected ? 'primary' : undefined"
      prepend-icon="mdi-printer"
      :variant="receiptToggleMode && printSelected ? 'tonal' : 'text'"
      @click="$emit('print')"
      >Print receipt</v-btn
    >
    <v-btn
      :disabled="busy || !order || emailDisabled || receiptDisabled"
      :aria-pressed="receiptToggleMode ? emailSelected : undefined"
      :color="receiptToggleMode && emailSelected ? 'primary' : undefined"
      prepend-icon="mdi-email"
      :variant="receiptToggleMode && emailSelected ? 'tonal' : 'text'"
      @click="$emit('email')"
      >Email receipt</v-btn
    >
    <v-btn
      v-if="closable"
      :disabled="busy"
      aria-label="Close shop"
      icon="mdi-close"
      variant="text"
      @click="$emit('close')"
    />
  </v-card-title>
</template>

<script setup lang="ts">
import type { OrderStaff } from "../../../cbi-generator/generated/dto/OrderStaff";
withDefaults(
  defineProps<{
    order: Pick<OrderStaff, "assignId" | "orderStatus" | "personId"> | null;
    busy?: boolean;
    editableBuyer?: boolean;
    buyerLink?: boolean;
    orderLink?: boolean;
    emailDisabled?: boolean;
    receiptToggleMode?: boolean;
    receiptDisabled?: boolean;
    printSelected?: boolean;
    emailSelected?: boolean;
    closable?: boolean;
  }>(),
  { orderLink: true },
);
defineEmits<{ "edit-buyer": []; print: []; email: []; close: [] }>();
</script>
